import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { withSystem, withoutSystem } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-41" data-mp="1xp3h5h4nfwsp">
      <div className="mx-auto max-w-5xl" data-id="element-42" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title="Imagine Your Next Class..." data-id="element-43" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-44" data-mp="1nxz26hez4bxv">
          <div className="rounded-[20px] bg-brand-paper p-7 sm:p-9" data-id="element-45" data-mp="1srtug98n9z8k">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-46" data-mp="1eznh0uwvm6ct">
              Without Hair Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-47" data-mp="1jwdqv0i385ps">
              {withoutSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-48" data-mp="153k3yu0hknb3">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-49" data-mp="277glaghtzw6x" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(72,103,70,0.55)] sm:p-9" data-id="element-50" data-mp="2g8wx8soao6d9">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-51" data-mp="2c7ba8ei1qbpc">
              With Hair Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-52" data-mp="1jinueyg2gej6">
              {withSystem.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-53" data-mp="1x9spdn8hoin6">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-54" data-mp="1si0ytcpc2cx1" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-14 text-center font-display text-[2.2rem] font-bold leading-none text-brand-charcoal sm:text-[3rem]" data-id="element-55" data-mp="10pk1xgel47q5">
          Less Prep. <Accent data-id="element-56" data-mp="34uzdhydotd98">More Teaching.</Accent>
        </p>
      </div>
    </section>;
}